<template>
  <div>
    <!-- <h4 class="mt-5">isStatusChecklistLoading</h4> -->
    <!-- ChecklistId -->
    <b-form-group label="Checklist" label-for="ChecklistId">
      <b-input-group>
        <b-form-input
          id="ChecklistId"
          type="text"
          placeholder="Checklist"
          v-model="model.checklistId"
          :readonly="readonly"
        />
        <b-input-group-append lg="6" md="6" sm="12">
          <router-link :to="urlChecklist">
          <label class="file">
            <i class="tim-icons icon-notes"></i>
          </label>
          </router-link>
        </b-input-group-append>
      </b-input-group>
      <span class="text-danger" v-if="modelstate['ChecklistId']">
        {{ modelstate["ChecklistId"][0] }}
      </span>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "CargoCrudChecklistId",
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
  data() {
    return {
      urlChecklist: true,
    };
  },
  created() {
    if (this.model.checklistId) {
      this.urlChecklist = `/trackingShippingCompany/checklist/fill/${this.model.checklistId}`;
      this.loadNewUrl(this.model.checklistId);
    }
  },
  methods: {
    dateToString(date) {
      if (date) {
        if (date != null && date != "") {
          return date.split("T")[0];
        }
      }
      return null;
    },
    async loadNewUrl(checklistId) {
      if (checklistId) {
        this.$apiChecklist
          .get(`/v2/checklist/get/${checklistId}`)
          .then((response) => {
            let checklist = response.data;
            if (checklist) {
              if (checklist.draft == false) {
                this.urlChecklist = `/trackingShippingCompany/checklist/filled/details/${checklistId}`;
              }
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          });
      }
    },
  },
};
</script>

<style>
/* .custom-file-label {
  border: none;
  display: none;
} */
</style>

<style scoped>
.file {
  background: #2c3b5d;
  width: 3rem;
  height: 90%;
  padding-top: 8px;
  padding-left: 14px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
</style>